// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  vgmKey: __t.string().primaryKey().name("vgm_key"),
  vguildId: __t.u64().name("vguild_id"),
  versonaId: __t.u64().name("versona_id"),
  rank: __t.string(),
  joinedAt: __t.timestamp().name("joined_at"),
});
